module.exports = __webpack_public_path__ + "static/model-keycaps-0443f37a0a013a255926927adafca15f.png";